import { formatEnumToReadableText } from '@consigli/utils';

interface ConflictTypeBadgeProps {
  conflictType: string;
  variant?: 'orange' | 'purple' | 'blue';
}

const variantStyles = {
  orange: 'bg-meeting-100 text-meeting-600',
  purple: 'bg-meeting-200 text-meeting-600',
  blue: 'bg-meeting-50 text-meeting-700',
};

export const ConflictTypeBadge = ({ conflictType, variant = 'orange' }: ConflictTypeBadgeProps) => {
  return (
    <span className={`text-xs px-2 py-1 rounded-full font-medium ${variantStyles[variant]}`}>
      {formatEnumToReadableText(conflictType || '')}
    </span>
  );
};
